import './BasketProductInfoTable.scss'

import { DeleteFilled, DeleteOutlined } from '@ant-design/icons'
import { Button, Image, message, Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import useMediaQuery from 'hooks/useMediaQuery'
import React from 'react'
import { ETIKET_URUN_ID } from 'utils/const'

import { SepetSatiri } from '../../gql/GeneratedGraphqlTypes'
import { getEffectiveMaxAdet, setPriceFormat } from '../../utils/helpers'
import QuantitySelector from '../quantity-selector/QuantitySelector'
import { BasketProductItem } from './types'

interface Props {
  data: SepetSatiri
  onChanges: (
    id: number,
    adet: number, // Change this to only accept a number type
  ) => void
  onDeleteChange: (id: number) => void
  isBasketTableVisible: boolean
  showIndirimsizFiyat?: boolean
}

const BasketProductInfoTable = ({ data, onChanges, onDeleteChange, isBasketTableVisible, showIndirimsizFiyat = true }: Props) => {
  const isCustomTabletDimen = useMediaQuery(960)

  if (!data) {
    return null
  }

  console.log('data', data)

  const BasketProductItems: BasketProductItem[] = [
    {
      key: data.urun?.id?.toString() || '',
      urun_bilgisi: data.urun?.isim!,
      adet: data.adet,
      tutar: (parseInt(data.indirimli_birim_fiyat || '0') * data.adet).toString(), // Sayısal tipe dönüşüm yapılıyor
    },
  ]

  const handleDelete = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    onDeleteChange(data.id)
  }

  const handleIncrement = () => {
    const newValue = data.adet + 1
    const maxAdet = getEffectiveMaxAdet(data.urun?.bilgiler, data.max_adet)
    if (newValue <= maxAdet) {
      onChanges(data.id, newValue)
    } else {
      message.warning('Bu üründe adet sınırı uygulanmaktadır. Daha fazla satın alınamaz.')
    }
  }

  // Eksi düğmesine tıklandığında çalışacak fonksiyon
  const handleDecrement = () => {
    const newValue = data.adet - 1 // Değeri bir azaltın
    if (newValue >= 1) {
      // Değer 1'den büyükse, onayla
      onChanges(data.id, newValue)
    }
  }

  var columns: ColumnsType<BasketProductItem> = [
    {
      dataIndex: 'urun_bilgisi',
      key: 'urun_bilgisi',
      width: '65%',
      render: (_: any, record: BasketProductItem) => {
        const etiketParts = data.urun?.id === ETIKET_URUN_ID && data.ogrenci_ismi
          ? data.ogrenci_ismi.split('|')
          : null
        return (
          <div className="product-info-table">
            <Image width={80} height={80} src={data.urun?.resimler?.[0] ?? ''} alt="ürün resmi" style={{ objectFit: 'contain' }} />
            <div className="product-info-text">
              <span>{data.urun?.isim}</span>
              {etiketParts && (
                <div className="etiket-bilgi">
                  <span>{etiketParts[0]} {etiketParts[1]}</span>
                  {etiketParts[3] && <span>{etiketParts[3]}</span>}
                  {etiketParts[2] && <span>No: {etiketParts[2]}</span>}
                </div>
              )}
            </div>
          </div>
        )
      },
    },
    {
      title: 'Adet',
      dataIndex: 'adet',
      key: 'adet',
      width: '20%',
      align: 'center',
      render: () => {
        // ToDo: disabled özelliği ürünün sınıftaki zorunluluğuna göre düzenlenmeli
        return (
          <QuantitySelector
            data={data}
            kaplama={data.urun?.id!}
            handleDecrement={handleDecrement}
            handleIncrement={handleIncrement}
          />
        )
      },
    },
    {
      dataIndex: 'tutar',
      key: 'tutar',
      width: '15%',
      align: 'center',
      render: () => {
        // Todo: İndirimsiz fiyat daha küçük ise gösterilmeyecek
        const value = data?.adet
        return (
          <div className='table-discount-price-container'>
            {showIndirimsizFiyat && parseInt(data.indirimli_birim_fiyat) < parseInt(data.indirimsiz_birim_fiyat) ? (
              <span className="table-price table-price-discount">
                {setPriceFormat(String(data.indirimsiz_birim_fiyat || '0').toString(), value!)} &#8378;
              </span>
            ) : null}
            <span className="table-price">
              {setPriceFormat(String(data.indirimli_birim_fiyat || '0').toString(), value!)} &#8378;
            </span>
          </div>
        )
      },
    },
    {
      dataIndex: 'sil',
      key: 'sil',
      align: 'center',
      width: '10%',
      render: (_, record) => {
        return (
          // ToDo: disabled özelliği ürünün sınıftaki zorunluluğuna göre düzenlenmeli
          <>
            <Button type="text" size="middle" onClick={handleDelete}>
              <DeleteFilled style={{ color: '#FF9A9A' }} />
            </Button>
          </>
        )
      },
    },
  ]

  const tabletAndMobileColumns: ColumnsType<BasketProductItem> = [
    {
      dataIndex: 'urun_bilgisi',
      key: 'urun_bilgisi',
      width: '50%',
      onCell: () => {
        return {
          style: {
            padding: '16px 0px',
          },
        }
      },
      render: (text: string) => {
        return (
          <div className="product-info-table">
            <Image width={60} height={60} src={data.urun?.resimler?.[0] ?? ''} alt="ürün resmi" style={{ objectFit: 'contain' }} />
            <div className="product-info-text">
              <span>{text}</span>
            </div>
          </div>
        )
      },
    },
    {
      title: 'Adet',
      dataIndex: 'adet',
      key: 'adet',
      align: 'center',
      onCell: () => {
        return {
          style: {
            padding: '16px 0px',
          },
        }
      },
      render: (urun: number) => {
        const value = data?.adet
        // ToDo: disabled özelliği ürünün sınıftaki zorunluluğuna göre düzenlenmeli
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div className="table-discount-price-container">
              {showIndirimsizFiyat && parseInt(data.indirimli_birim_fiyat) < parseInt(data.indirimsiz_birim_fiyat) && (
                <span className="table-price table-price-discount">
                  {setPriceFormat(String(data.indirimsiz_birim_fiyat || '0').toString(), value!)} &#8378;
                </span>
              )}
              <span className="table-price">
                {setPriceFormat(String(data.indirimli_birim_fiyat || '0').toString(), value!)} &#8378;
              </span>
            </div>

            <QuantitySelector
              data={data}
              kaplama={data.urun?.id!}
              handleDecrement={handleDecrement}
              handleIncrement={handleIncrement}
            />
          </div>
        )
      },
    },
    {
      dataIndex: 'sil',
      key: 'sil',
      align: 'center',
      onCell: () => {
        return {
          style: {
            padding: '16px 0px',
          },
        }
      },
      render: (_, record) => {
        return (
          // ToDo: disabled özelliği ürünün sınıftaki zorunluluğuna göre düzenlenmeli
          <>
            <Button type="text" size="middle" onClick={handleDelete}>
              <DeleteOutlined style={{ color: 'red' }} />
            </Button>
          </>
        )
      },
    },
  ]

  if (isCustomTabletDimen) {
    columns = tabletAndMobileColumns
  }

  return (
    <>
      {isBasketTableVisible && ( // Conditionally render the table when isBasketTableVisible is true
        <Table
          className="products-info-table"
          columns={columns}
          dataSource={BasketProductItems}
          pagination={false}
          showHeader={false}
        />
      )}
    </>
  )
}

export default BasketProductInfoTable
